import { render, staticRenderFns } from "./ModalFunciones.vue?vue&type=template&id=509151bf"
import script from "./ModalFunciones.vue?vue&type=script&lang=js"
export * from "./ModalFunciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports